export default "__VITE_ASSET__C$pgLetG__"